import 'immer';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import type {
  Item,
  ItemSearchOutput,
  ItemSearchInput,
} from '@repo/api-contract';
import ApiClient from '../../util/api-client';
type SearchBy = ItemSearchInput['searchBy'];

export interface ItemBrowseState {
  searchInput: string;
  results?: ItemSearchOutput;
  searchBy: SearchBy;
  loading: boolean;
  activeSelection?: Item;
}

// Initialize state
const initialState: ItemBrowseState = {
  searchInput: '',
  results: undefined,
  searchBy: 'vendorItemNumber',
  loading: false,
  activeSelection: undefined,
};

export const itemBrowseSlice = createSlice({
  name: 'itemBrowse',
  initialState,
  reducers: {
    setSearchInput: (state, action: PayloadAction<string>) => ({
      ...state,
      searchInput: action.payload,
    }),
    setSearchBy: (state, action: PayloadAction<SearchBy>) => ({
      ...state,
      searchBy: action.payload,
    }),
    setResults: (
      state,
      action: PayloadAction<ItemSearchOutput | undefined>,
    ) => ({
      ...state,
      results: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setActiveSelection: (state, action: PayloadAction<Item>) => ({
      ...state,
      activeSelection: action.payload,
    }),
  },
});

export const {
  setSearchInput,
  setSearchBy,
  setResults,
  setLoading,
  setActiveSelection,
} = itemBrowseSlice.actions;
export default itemBrowseSlice.reducer;

// Thunks
export const searchItems =
  (searchInput: ItemSearchInput) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      dispatch(setLoading(true));
      const results = await ApiClient.searchItems.query(searchInput);
      dispatch(setResults(results));
    } catch (error: unknown) {
      dispatch(setResults(undefined));
    } finally {
      dispatch(setLoading(false));
    }
  };
